/**
 * Mã quyền lợi nào KHÔNG hiện trong bảng so sánh gói (#19892 mục 3 + 4).
 *
 * <p><b>Vì sao ẩn, chứ không xoá mã.</b> Hai mã dưới đây được seed `'on'` cho PRO và TRIAL
 * (`V20260587`), nên bảng so sánh gói hiện "✓" cho chúng — trong khi đo ra thì:
 *
 * <ul>
 *   <li>`module.bhyt-export` — **không một dòng mã nào** trong repo nhắc tới việc xuất BHYT, ngoài
 *       chính hằng số trong `EntitlementCode`. Đây là một quyền lợi đi TRƯỚC tính năng của nó.
 *   <li>`module.advanced-reports` — **không màn nào đọc**. Nó chỉ xuất hiện ở bảng nhãn và ở
 *       `PRO_DENY_FALLBACK`; `ReportsController` có 8 endpoint và chỉ `/coupons` có cổng, bằng
 *       `MODULE_COUPON`. Không có ranh giới "báo cáo nâng cao" nào tồn tại trong mã.
 * </ul>
 *
 * Một dấu "✓" cho một tính năng không tồn tại là một lời hứa bán hàng mà sản phẩm không giữ được.
 *
 * <p>Chủ sản phẩm chốt (#19892, ghi chú 81972): *"Advanced Reports: Giữ nguyên các báo cáo hiện tại
 * cho BASIC và PRO. Tạm ẩn tính năng Advanced Reports khỏi bảng so sánh gói. Không tự ý chặn các
 * API báo cáo hiện có."* và *"BHYT Export: Chưa triển khai thì tạm ẩn khỏi bảng so sánh gói. Giữ mã
 * entitlement để sử dụng sau."*
 *
 * <p><b>Nên đây là một luật HIỂN THỊ, và chỉ vậy.</b> Mã vẫn ở `EntitlementCode`, vẫn được seed,
 * vẫn ở `FEATURE_LABELS` và `PRO_DENY_FALLBACK` — gỡ chúng khỏi những chỗ đó sẽ làm
 * `WebEntitlementCodesTest` đỏ và sẽ xoá mất thứ cần dùng lại khi tính năng được làm thật. Không
 * có cổng backend nào được thêm hay bớt cho hai mã này: "tạm ẩn khỏi bảng" không phải "chặn API".
 */
export const HIDDEN_PLAN_COMPARISON_CODES: ReadonlySet<string> = new Set([
  "module.bhyt-export",
  "module.advanced-reports",
]);

/**
 * Lọc danh sách mã của bảng so sánh gói.
 *
 * Giữ nguyên thứ tự đầu vào — bảng tự sắp xếp ở chỗ dựng `allCodes`, và đổi thứ tự ở đây là đổi
 * hai thứ trong một hàm.
 */
export function planComparisonCodes(codes: readonly string[]): string[] {
  return codes.filter((c) => !HIDDEN_PLAN_COMPARISON_CODES.has(c));
}
